const images = require.context('../img/slider', false, /\.(jpg|jpeg|png)$/);

const imageArray = images.keys().map((file, index) => ({
  src: images(file).default || images(file),
  width: 1500,
  height: 2500,
  alt: `Alt image ${index + 1}`,
}));

export {imageArray};
